var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3878 7.52168V9.76139H5.78854V22.0798H18.107V16.4805H20.3467V23.1997C20.3467 23.4967 20.2287 23.7815 20.0187 23.9915C19.8087 24.2016 19.5238 24.3195 19.2268 24.3195H4.66869C4.37168 24.3195 4.08684 24.2016 3.87683 23.9915C3.66681 23.7815 3.54883 23.4967 3.54883 23.1997V8.64154C3.54883 8.34453 3.66681 8.05969 3.87683 7.84968C4.08684 7.63967 4.37168 7.52168 4.66869 7.52168H11.3878ZM23.7063 4.16211V13.121H21.4665V7.98418L12.7395 16.7123L11.156 15.1289L19.8819 6.40182H14.7474V4.16211H23.7063Z",
    fill: "#ACACAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkLine);
export default __webpack_public_path__ + "static/media/external-link-line.dab75ccdf60cd697961afa3e9906afbe.svg";
export { ForwardRef as ReactComponent };